export default __webpack_public_path__ + "static/media/trophyLbIcon.6d04c4df.svg";